import React from 'react';
import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../helpers/getBaseProduct';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Heading } from '../../Common/Heading';
import { Caption } from '../../Common/Caption';
import { Selector, SelectorItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  bracketColour: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (bracketColour, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      bracketColour,
    },
  });

const onClickForComponents: OnClick = (componentsColour, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      componentsColour,
    },
  });

const onClickForChain: OnClick = (chainColour, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      chainColour,
    },
  });

const onClickForBottomBar: OnClick = (bottomBarColour, send) => () =>
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      bottomBarColour,
    },
  });

export const BracketColour = () => {
  const [state, send] = useService(productBuilderMachine);
  const baseProduct = getBaseProduct(state.context);
  const bracketColourOptions = baseProduct
    ? baseProduct.metafields.bracket_colour || []
    : [];
  const componentsColourOptions = baseProduct
    ? baseProduct.metafields.components_colour || []
    : [];

  const chainColourOptions = baseProduct
    ? baseProduct.metafields.chain_colour || []
    : [];

  const bottomBarColourOptions = baseProduct
    ? baseProduct.metafields.bottom_bar_colour || []
    : [];
  const {
    products,
    custom: { bracketColour, componentsColour, bottomBarColour, chainColour, materialType, colour },
  } = state.context;

  if (isCurrentState('bracketColour', state) && bracketColourOptions.length === 0) {
    throwError(state);
  }

  let rollerPremiumCorded = products.filter(ele =>
    ele.title?.toLowerCase()?.includes(`Material: ${materialType}`?.toLowerCase()) &&
    ele.title?.toLowerCase()?.replace("-", " ")?.includes(`${colour}`?.toLowerCase()) &&
    ele?.metafields?.supplier != undefined
  )

  return (
    rollerPremiumCorded ?
      <>
        <SectionContent isBracketOption={true}>
          {/* <Heading>Bracket colour</Heading> */}
          <Caption isBracketOption={true}>Bracket colour</Caption>
          <Selector isBracketOption={true}>
            {bracketColourOptions.map(option => {
              return (
                <SelectorItem
                  isSelected={option === bracketColour}
                  onClick={onClick(option, send)}
                  key={option}
                  isBracketOption={true}
                >
                  {option}
                </SelectorItem>
              );
            })}
          </Selector>
        </SectionContent>
        <SectionContent isBracketOption={true}>
          <Caption isBracketOption={true}>Components colour</Caption>
          <Selector isBracketOption={true}>
            {componentsColourOptions.map(option => {
              return (
                <SelectorItem
                  isSelected={option === componentsColour}
                  onClick={onClickForComponents(option, send)}
                  key={option}
                  isBracketOption={true}
                >
                  {option}
                </SelectorItem>
              );
            })}
          </Selector>
        </SectionContent>
        <SectionContent isBracketOption={true}>
          <Caption isBracketOption={true}>Chain colour</Caption>
          <Selector isBracketOption={true}>
            {chainColourOptions.map(option => {
              return (
                <SelectorItem
                  isSelected={option === chainColour}
                  onClick={onClickForChain(option, send)}
                  key={option}
                  isBracketOption={true}
                >
                  {option}
                </SelectorItem>
              );
            })}
          </Selector>
        </SectionContent>
        <SectionContent isBracketOption={true}>
          <Caption isBracketOption={true}>Bottom bar colour</Caption>
          <Selector isBracketOption={true}>
            {bottomBarColourOptions.map(option => {
              return (
                <SelectorItem
                  isSelected={option === bottomBarColour}
                  onClick={onClickForBottomBar(option, send)}
                  key={option}
                  isBracketOption={true}
                >
                  {option}
                </SelectorItem>
              );
            })}
          </Selector>
        </SectionContent>
      </>
      :
      <SectionContent isBracketOption={false}>
        <Heading>Bracket colour</Heading>
        <Caption isBracketOption={false}>Bracket colour</Caption>
        <Selector isBracketOption={false}>
          {bracketColourOptions.map(option => {
            return (
              <SelectorItem
                isSelected={option === bracketColour}
                onClick={onClick(option, send)}
                key={option}
                isBracketOption={false}
              >
                {option}
              </SelectorItem>
            );
          })}
        </Selector>
      </SectionContent>
  );
};
